

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import mixins from "vue-typed-mixins";

// Project
import SeoMeta from "~/mixins/SeoMeta";
import { ContentNode, HtmlHeadMeta, GlobalInjectionInterface } from "~/libs/Types";

// Local helper functions ------------------------------------------------------

/**
 * Adds router path to node. This is a separate function because Vue methods and
 * computed's are not available in vue/nuxt lifecycle hooks.
 */
function nodeWithRoute (node: ContentNode, vm: Vue): ContentNode {
    node.fullPath = vm.$route.fullPath;
    return node;
}

// Export ----------------------------------------------------------------------

export default mixins(SeoMeta).extend({

    // Component imports -------------------------------------------------------

    components: {
        // Dynamic imports are used so as to only import the layout that is used
        HeroLayout: () => import("~/layouts/Hero.vue"),
        SimpleLayout: () => import("~/layouts/Simple.vue"),
        DefaultLayout: () => import("~/layouts/Default.vue"),
        UniversalLayout: () => import("~/layouts/Universal.vue")
    },

    // Component Attribute Properties ------------------------------------------

    props: {
        node: {
            type: Object as () => ContentNode,
            required: true
        }
    },

    // Nuxt/Vue Hooks ----------------------------------------------------------

    /**
     * Provide common and deeply required variables.
     *
     * @returns Object
     */
    provide (): GlobalInjectionInterface {
        return {
            node: this.nodeWithPath
        };
    },

    /**
     * Generate and set HTML head attributes.
     *
     * @return HtmlHeadMeta
     */
    head (): HtmlHeadMeta {
        return this.nodeMeta;
    },

    // Component Computed Properties -------------------------------------------

    computed: {
        /**
         * See if a node has a configured override layout or use the defaut.
         *
         * @returns string
         */
        nodeLayout (): string {
            if (this.node.page?.layout) {
                return this.node.page.layout + "Layout";
            }

            // Default layout
            return "SimpleLayout";
        },

        /**
         * Add vue-route full path to node.
         */
        nodeWithPath (): ContentNode {
            return nodeWithRoute(this.node, this);
        },

        /**
         * Build meta data from node.
         */
        nodeMeta (): HtmlHeadMeta {
            return this.buildMetaData(this.nodeWithPath);
        }
    }

    // -------------------------------------------------------------------------
});

